<div class="settings">
  <h1>{{ 'label.Settings' | translate }}</h1>
  <br />
  <div class="column left">
    <div class="section">
      <div>{{ 'label.GeneralSettings' | translate }}</div>
      <div>
        <ul>
          <li>{{ 'label.DefaultLanguage' | translate }}</li>
          <li>
            <a [routerLink]="['../system-configuration']">
              {{ 'label.SystemConfiguration' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="section">
      <div>{{ 'label.Internationalization' | translate }}</div>
      <div>
        <ul>
          <li>{{ 'label.Labels' | translate }}</li>
          <li>{{ 'label.TextualContent' | translate }}</li>
          <li>{{ 'label.Messages' | translate }}</li>
        </ul>
      </div>
    </div>
    <div class="section">
      <div>{{ 'label.UserManagement' | translate }}</div>
      <div>
        <ul>
          <li>
            <a [routerLink]="['../admin-users']">
              {{ 'label.Users' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="column">
    <div class="section">
      <div>{{ 'label.LookupInformation' | translate }}</div>
      <div>
        <ul>
          <li>{{ 'label.Categories' | translate }}</li>
          <li>
            {{ 'label.Industries' | translate }}
          </li>
          <li>{{ 'label.Cities' | translate }}</li>
        </ul>
      </div>
    </div>
    <div class="section">
      <div>{{ 'label.Content' | translate }}</div>
      <div>
        <ul>
          <li>
            <a [routerLink]="['../template-list']">
              {{ 'label.EmailAndSmsTemplates' | translate }}
            </a>
          </li>
          <li>
            <a [routerLink]="['../promo-emails']">
              {{ 'label.PromoEmailTemplates' | translate }}
            </a>
          </li>
          <li>
            <a [routerLink]="['../info-pages']">
              {{ 'label.InfoPages' | translate }}
            </a>
          </li>
          <li>
            <a [routerLink]="['../banner-positions']">
              {{ 'label.ManageBanners' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
